<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
    <div ref="chart" class="chart-container"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "EChartsExample",
  props: ['params'],
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    params: function (val, oldVal) {
      this.initChart(val)
    }
  },
  mounted() {
    this.loading = true
  },
  methods: {
    initChart() {
      let breakEven = []
      Object.keys(this.params.bk_point_dict).forEach(item => {
        breakEven.push({
          name: item + '年盈亏平衡点',
          type: 'line',
          data: new Array(this.params.max_ranking).fill(this.params.bk_point_dict[item]),
          lineStyle: {
            width: 2,
            type: 'dashed'
          }
        })
      })
      // 初始化echarts实例
      const chart = echarts.init(this.$refs.chart);

      // 图表配置
      const chartOption = {
        title: {
          text: '',
          textStyle: {
            color: "#FFFFFF", // 白色标题
            fontSize: 20,
          },
          padding: [0, 0, 20, 0], // 标题与图表间距
          left: "center",
          top: "1%",
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#FFF", // 设置工具提示背景色
          textStyle: {
            color: "#000", // 白色文本
          },
          formatter: function(params){
            let str = ''
            str += '排名：' + params[0].axisValue + '<br />'
            str += '景区：' + '<br />'
            params.forEach(item => {
              if(Object.keys(item.data).length){
                str += item.data.year + '：'  + item.data.scenic + '<br />'
              }
            })
            str += '<br />'
            params.forEach(item => {
              str += item.seriesName + '：'  + item.value + '元' + '<br />'
            })
            return str
          }
        },
        legend: {
          textStyle: {
            color: "#FFFFFF", // 白色文字
          },
          padding: [20, 0, 20, 0], // 设置legend上下间距
        },
        grid: {
          left: "5%",
          right: "10%",
          top: "10%",
          bottom: "15%",
          containLabel: true, // 包含坐标轴标签
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.params.rankings,
          axisLabel: {
            color: "#FFFFFF", // 白色坐标轴文字
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#FFFFFF", // 白色坐标轴线
            },
          },
        },
        yAxis: [{
          type: "value",
          name: "单台产值（元）",
          axisLabel: {
            formatter: "{value} 元",
            color: "#FFFFFF", // 白色坐标轴文字
            fontSize: 12,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#FFFFFF", // 白色坐标轴线
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#beb1b1", // 辅助线颜色
            },
          },
        },
        
        ],
        dataZoom: [
          {
            type: "slider",
            start: 0, //数据窗口范围的起始百分比0-100。
            end: 100, //数据窗口范围的结束百分比0-100。
            labelStyle: {
              color: "#FFF",
            },
            label: {
              show: true,
              color: "#FFF", // 默认字体颜色
            },
            textStyle: {
              color: "#FFF",
            },
            emphasis: {
              label: {
                color: "#FFF", // 鼠标放到dataZoom上时的字体颜色
              },
            },
          },
          // {
          //   type: "inside", // 内置型数据缩放（支持鼠标滚轮缩放）
          //   start: 0,
          //   end: 100,
          // },
        ],
        series: [
          ...this.params.series_data.map(item => ({
            ...item,
            data: item.data.map((key, index) => ({
              value: key,
              year: item.year,
              scenic: item.companies[index],
              breakEvens: this.params.bk_point_dict[item.year]
            }))
          })),
          ...breakEven
        ],
      };

      // 设置图表选项
      chart.setOption(chartOption);
      this.loading = false
    },
  },
};
</script>

<style scoped>
.outBox {
  width: 100%;
  height: 620px;
  /*border: 1px solid #4688ff;*/
}

.box {
  width: 100%;
  height: 620px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}
</style>
